module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido1.dc8301da.svg";